import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Dialog, DialogFooter, DialogType, Fabric, TextField, PrimaryButton } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth/selector';
import { login, validateAuth } from 'store/auth/actions';
import { LoadingIndicator } from 'layout/LoadingIndicator/LoadingIndicator';
import { initializeIcons } from '@fluentui/react/lib/Icons';

import styles from './Login.module.scss';

initializeIcons();

export const Login: React.FC = () => {
    const [mail, setMail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const auth = useSelector(authSelector);
    const location = useLocation();
    const history = useHistory();

    const loginUser = (): void => {
        login(mail, password).then();
    };

    React.useEffect(() => {
        validateAuth().then();
    }, []);

    React.useEffect(() => {
        if (auth.isAuthenticated) {
            const urlSearchParams = new URLSearchParams(location.search);
            const redirect = urlSearchParams.get('redirect');

            if (redirect && redirect.length > 4) {
                history.push(redirect);
            } else {
                history.push('/kunden');
            }
        }
    }, [auth, history, location]);

    return (
        <>
            {auth.isValidating || (
                <Fabric className={styles.container}>
                    <Dialog
                        hidden={false}
                        dialogContentProps={{
                            type: DialogType.largeHeader,
                        }}
                        title="SalesMaster Login"
                    >
                        {/* <img className={styles.logo} src={logo} alt="logo" /> */}
                        <form>
                            <TextField
                                value={mail}
                                onChange={(event, newValue): void => {
                                    setMail(newValue === undefined ? '' : newValue);
                                }}
                                label="E-Mail"
                                placeholder="...@bdspack.at"
                            />
                            <TextField
                                value={password}
                                type="password"
                                onChange={(event, newValue): void => {
                                    setPassword(newValue === undefined ? '' : newValue);
                                }}
                                label="Passwort"
                                placeholder=""
                            />
                            {auth.error && <div>{auth.error}</div>}
                            <DialogFooter>
                                <PrimaryButton onClick={loginUser} text="Login" />
                            </DialogFooter>
                        </form>
                    </Dialog>
                </Fabric>
            )}
            {auth.isLoading && <LoadingIndicator />}
        </>
    );
};
